import styled from "styled-components";

const InfoCard = styled.div`
  min-height: 100%;
  border-radius: 15px;
  padding: 20px;
  background: #ffffff;
  ${(props) =>
    props.hasShadow
      ? "box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 0px 6px rgba(0, 0, 0, 0.15);"
      : "border: 1px solid #c0c0c0;"}

  min-height: 100%;
  .edit-icon-wrapper {
    width: 32px;
    height: 32px;
    background: #f0f0f0;
    border-radius: 5px;
  }
`;

export default InfoCard;
